<template>
  <div id="editPsd">
    <headNav>
      <div slot="headNavText">{{$t('message.edit_psd')}}</div>
    </headNav>
    <div class="container">
      <div class="banksBox">
        <div class="form_item">
          <div class="form_label"><span>*</span>{{$t('message.ipt_old_psd')}}</div>
          <div class="ipt">
            <van-field v-model="newPsd" placeholder="" type="password"/>
            <div class="ipt_img"><img src="../../assets/images/3x/pass.png" alt=""></div>
          </div>
        </div>
        <div class="form_item">
          <div class="form_label"><span>*</span>{{$t('message.ipt_psd')}}</div>
          <div class="ipt">
            <van-field v-model="againNewPsd" placeholder="" type="password"/>
            <div class="ipt_img"><img src="../../assets/images/3x/pass.png" alt=""></div>
          </div>
        </div>
        <div class="tips">
          *{{$t('message.edit_cs_psd')}}
        </div>
        <van-button type="primary" block style="margin-top: 15px" @click="confirmChangePwd" id="btns">
          {{$t('message.edit_com')}}
        </van-button>
      </div>

    </div>
  </div>
</template>

<script>
  import headNav from "../HeadNav/headNav";
  import {modifyPassword} from '../../ports/port'

  export default {
    name: "editPsd",
    data() {
      return {
        show: false,
        newPsd: '',
        againNewPsd: '',
        tk: JSON.parse(localStorage.getItem("tokenAll")),
      }
    },
    components: {
      headNav
    },
    methods: {
      confirmChangePwd() {
        this.$store.commit('edit', true);//打开全局的loading
        modifyPassword({userid: this.tk.userid, password: this.newPsd, new_password: this.againNewPsd})
          .then(res => {
            this.$store.commit('edit', false);//关闭全局的loading
            if (res.data.code == 200) {
              this.$notify({
                type: 'success', message: this.$t('message.edit_success'), onClose: () => {
                  this.$router.push("/home/my");
                }
              });
            } else {
              this.$notify({type: 'danger', message: this.$t('message.edit_error')});
            }
          })
          .catch(err => {
            this.$store.commit('edit', false);//关闭全局的loading
            if (err.toString().indexOf('timeout') != -1) {
              this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
            }
          })
      }
    }
  }
</script>

<style scoped lang="scss">
  #editPsd {
    display: flex;
    flex-direction: column;
    min-height: 100vh;

    .container {
      background: #fff;
      padding: 55px 15px 0;
      flex: 1;

      .title {
        text-align: center;
        background: white;
        font-size: 20px;
        padding-top: 20px;
        padding-bottom: 15px;
        border-bottom: 1px solid #F2F4FB;
        position: relative;

        i {
          position: absolute;
          left: 20px;
          font-size: 25px;
        }
      }

      .banksBox {

        background: white;
        width: 95%;

        margin: 15px auto;
        border-radius: 8px;

        button {
          background: $color;
          border: 1px solid $color;
          border-radius: 5px;
        }

      }
    }

    /deep/ .van-cell.van-field {
      border-radius: 8px !important;
      border: 1px solid #cccccc !important;
    }

    .form_item {
      margin-bottom: 0.36rem;

      .form_label {
        color: #969696;
        font-size: 14px;
        font-weight: 400;
        margin-bottom: 0.27rem;

        span {
          color: #FF0300;
          margin-right: 3px;
        }
      }
    }

    .tips {
      color: #FF0300;
      font-size: 0.2rem;
    }

    #btns {
      @include defaultBtn
    }

    .ipt {
      position: relative;

      .ipt_img {
        position: absolute;
        top: 12px;
        left: 15px;

        img {
          height: 20px;
        }
      }
    }
  }

  /deep/ .van-field__control {
    padding-left: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/auth/editPsd.vue